import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UsersMeService } from './users-me.service';

export const mustChangePasswordGuard: CanActivateFn = (_route, state) => {
  const usersMeService = inject(UsersMeService);
  const router = inject(Router);

  const checkProfile = (): boolean | UrlTree => {
    const profile = usersMeService.profile();
    if (profile?.mustChangePassword) {
      return router.createUrlTree(['/auth/change-password'], {
        queryParams: { returnUrl: state.url },
      });
    }
    return true;
  };

  // Fast path — profile already resolved, no need to wait.
  if (!usersMeService.profileIsLoading()) {
    return checkProfile();
  }

  // Async path — profile is still loading (e.g. immediately after login).
  // Wait for loading to finish, then evaluate mustChangePassword.
  return toObservable(usersMeService.profileIsLoading).pipe(
    filter(loading => !loading),
    take(1),
    map(checkProfile)
  );
};
